export default __webpack_public_path__ + "61986f8776d91d9e20d85e32805633a4.png";